/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_Grower_PhInputs */

const vi_aml_form_grower_ph = /** @type {(inputs: Aml_Form_Grower_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn hộ trồng (tùy chọn)`)
};

/**

* @param {Aml_Form_Grower_PhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_grower_ph = /** @type {((inputs?: Aml_Form_Grower_PhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_Grower_PhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_grower_ph(inputs)
});